import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {Accordion, AccordionSummary, AccordionDetails} from "@material-ui/core";

const ExpansionPanel = withStyles({
    root: {
        border: "1px solid rgba(0,0,0,.125)",
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0
        },
        "&:before": {
            display: "none"
        },
        '&$expanded': {
            margin: '0'
        }
    },
    expanded: {
        margin: "auto"
    }
})(Accordion);
const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: "rgba(0,0,0,.03)",
        borderBottom: "1px solid rgba(0,0,0,.125)",
        marginBottom: -1,
        padding: '0 24px 0 8px',
        minHeight: 35,
        "&$expanded": {
            minHeight: 35
        }
    },
    expandIcon: {
        padding: 0
    },
    content: {
        margin: "0 0",
        '&>p': {
            fontSize: '0.875rem'
        },
        "&$expanded": {
            margin: "8px 0",
        }
    },
    expanded: {}
})(props => <AccordionSummary {...props} />);
const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(1),
        display: 'block'
    }
}))(AccordionDetails);

export {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails}
